module.exports = __webpack_public_path__ + "static/media/cog alt.b70884cf.png";